module.exports = __webpack_public_path__ + "img/c.732d4dcf.jpg";